require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2011-12-18-the-switch-python-to-node-js.json") })
        }
      }, "path---articles-2011-12-18-the-switch-python-to-node-js");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2011-12-18-the-switch-python-to-node-js!./.cache/json/articles-2011-12-18-the-switch-python-to-node-js.json
// module id = 613
// module chunks = 231608221292675